module.exports = __webpack_public_path__ + "static/img/fish30.d694b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish30.png
// module id = Rqwc
// module chunks = 0